import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { city, cityList, deleteCity, totalCity } from "./citySlice";
import Pagination from "react-js-pagination";
import DeleteModal from "../../../components/deleteModal";
import { toast } from "react-toastify";
import { useCallback } from "react";
import { debounce } from "lodash";

const DeliveryCityList = () => {
  // const data = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const History = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [id, setDeleteId] = useState("");

  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
  const data = useSelector(city);
  const total = useSelector(totalCity);

  const listing = useCallback(() => {
    dispatch(cityList(filters));
  }, [dispatch, filters]);

  useEffect(() => {
    listing();
  }, [listing]);

  const handlePageChange = (pageNumber) => {
    setFilters({
      ...filters,
      page: pageNumber,
    });
  };

  const handleChange = debounce((e) => {
    setFilters({
      ...filters,
      search: e.target.value,
    });
  }, 300);

  const toggle = () => {
    setModal(!modal);
  };

  const deleteCat = () => {
    dispatch(deleteCity({ id, filters })).then((data) => {
      if (data?.payload?.response_code === 200) {
        toggle();
        toast.success("Success");
      } else {
        toast.error(data?.payload?.message);
      }
    });
  };

  return (
    <article class="col-lg-9">
      <div class="article-body store-bd-gy">
        <div class="row align-items-center col-rever">
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div class="link-active">
              <img src="assets/images/Users-selected.png" alt="" />
              <span>
                <p>{total || "0"}</p>
                <p>Total Cities</p>
              </span>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div class="d-flex align-items-center lg-justify-content-end">
              <form class="has-search">
                <span class="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search State by name"
                  onChange={handleChange}
                />
              </form>
              <Link to="/admin/delivery-cities/add" class="add-new">
                + Add New
              </Link>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive text-center">
              <table class="table storetable">
                <thead class="text-center">
                  <tr>
                    <th scope="col">s.no.</th>
                    <th scope="col">Image</th>
                    <th scope="col">State</th>
                    <th scope="col">action</th>
                  </tr>
                  <tr class="border-0 bg-none invisible">
                    <td class="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    data.map((dataElem, i) => {
                      return (
                        <tr key={dataElem.id}>
                          <td>{i + 1}</td>
                          <td>
                            <div
                              style={{
                                height: "80px",
                                width: "80px",
                                margin: "0 auto",
                                borderRadius: "10px",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                alt=""
                                src={
                                  dataElem.image || "assets/images/employe.png"
                                }
                                class="object-fit-cover"
                              />
                            </div>
                          </td>
                          <td>{dataElem.state}</td>
                          <td>
                            <div class="d-flex justify-content-center action">
                              <button
                                onClick={() =>
                                  History.push(
                                    `/admin/delivery-cities/edit/${dataElem.id}`
                                  )
                                }
                                class="btn"
                              >
                                <img alt="" src="assets/images/edit.png" />
                              </button>
                              <button
                                onClick={() => {
                                  toggle();
                                  setDeleteId(dataElem.id);
                                }}
                                class="btn"
                              >
                                <img src="assets/images/delete.png" alt="" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4}>No Data Found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {total && total > 10 ? (
          <div>
            <Pagination
              activePage={filters.page}
              itemsCountPerPage={filters.limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <DeleteModal deleteCategory={deleteCat} modal={modal} toggle={toggle} />
    </article>
  );
};

export default DeliveryCityList;
